import { DEFAULT_ID_ATTRIBUTE_NAME } from "../evergis/constants";
import { compareByProp } from "./compareByProp";
import { ImportAttribute } from "../components/Dialogs/Import/types";

export const getIdAttribute = (attributes: ImportAttribute[], idAttribute?: string) => {
  if (idAttribute) {
    return idAttribute;
  }

  const idAttributes = attributes
    .filter(({ name }) => name.startsWith(DEFAULT_ID_ATTRIBUTE_NAME))
    .sort((a, b) => compareByProp("name", a, b));

  return idAttributes.pop()?.name || DEFAULT_ID_ATTRIBUTE_NAME;
};
